// EN-18 Review Mode routes.
export const REVIEW_SUMMARY_PATH = "/review/summary";
